/* eslint-disable no-unused-vars */
// incorrect work of lint rule in this file

/**
 * Словарь ключей брейкпоинтов
 */
export let BreakPointsKeys;

/**
 * Модель карты брейкпоинтов
 */
(function (BreakPointsKeys) {
  BreakPointsKeys["xxs"] = "xxs";
  BreakPointsKeys["xs"] = "xs";
  BreakPointsKeys["sm"] = "sm";
  BreakPointsKeys["md"] = "md";
  BreakPointsKeys["lg"] = "lg";
  BreakPointsKeys["xl"] = "xl";
})(BreakPointsKeys || (BreakPointsKeys = {}));